import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTiktokComponent } from './simple-icons-tiktok.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTiktokComponent ],
    exports:      [ SimpleIconsTiktokComponent ],
    bootstrap:    []
})
export class SimpleIconsTiktokModule {}
